import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";

import ProvinceModule from "@/store/modules/ProvinceModule";
import DistrictModule from "@/store/modules/DistrictModule";
import MapModule from "./modules/MapModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    ProvinceModule,
    DistrictModule,
    MapModule
  },
});

export default store;
